import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'limit' })
export class AtxLimitPipe implements PipeTransform {
    transform(pages: any, current: number, delay: number): string[] {
        let elements = [];
        let hasMore: boolean;

        for(let page of pages) {
            if (page === 1 ||
                (page >= current - delay && page <= current + delay) ||
                page === current ||
                page === pages.length
            ) {
                hasMore = false;
                elements.push({ label: page, page });
            } else if (!hasMore) {
                hasMore = true;

                elements.push({
                    label: '...',
                    page: page < current ? current - (delay + 1) : current + (delay + 1)
                });
            }
        }

        return elements;
    }
}
